import { ChartSankeyIcon } from './ChartSankeyIcon';

/**
 * author: Michael Richins
 * id D0F312B5-8B3B-4E68-BF0B-691D4F129749
 * name chart-sankey
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-sankey.svg
 * tags
 * - Math 
 */
export const WidgetSankeyIcon = ChartSankeyIcon;
export default WidgetSankeyIcon